import { defineMessages } from 'react-intl'

export default defineMessages({
  totalResults: {
    id: 'common.pagination.totalResults',
    defaultMessage:
      '{totalCount, plural, one {Displaying a total of {element} result} other {Displaying a total of {element} results}}',
  },
})
